import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useSessionId({
  token, avatarId, avatarName, bedrockAvatarId, bedrockAvatarAliasId,
}) {
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    axios
      .post(`${gon.ai_rest_api_base_url}/v1/chat/start`, {
        avatar_id: avatarId,
        avatar_name: avatarName,
        session_type: 'video',
        bedrock_avatar_id: bedrockAvatarId,
        bedrock_avatar_alias_id: bedrockAvatarAliasId,
      }, {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((response) => {
        setSessionId(response.data.session_id);
      });
  }, []);

  return sessionId;
}
